<template>
  <DBox
    :id="'cmp-settings-shipping-types'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('shipping_type')}`"
    @add_click="onAddLabelStatus"
  >
    <NTable
      id="catalog-projects-sidewindow-related_products-list"
      class="h1"
      :config="tableConfig"
      :headers="headers"
      :items="shipping_types"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('shipping_type')">
            <span
              class="txtov"
              :class="{
                'ut-fb ut-link': item.shipping_type_id != '',
              }"
              :title="item['shipping_type']"
              @click="(e) => onShippingTypeClick(item)"
            >
              {{ item["shipping_type"] }}
            </span>
          </td>
          <td v-bind="tdcon('service_code')">
            <span class="txtov" :title="item['service_code']">
              {{ $t(item["service_code"]) }}
            </span>
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click="(e) => onShippingTypeDelete(item)"
              class="dt-icon v5 s1"
              :alt="$t('delete_shipping_type')"
              :title="$t('delete_shipping_type')"
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import DBox from "@dtplugins/dbox/dbox";
import ColorPicker from "@plugins/color-picker/color-picker";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { createTableHeader, createNTableConfig } from "../../../../plugins/datatable";

export default {
  components: {
    DBox,
    ColorPicker,
  },
  props: {
    shipping_types: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        showHeader: false,
        rowHeight: 32,
      });
    },
    headers() {
      return [
        createTableHeader("shipping_type"),
        createTableHeader("service_code"),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  methods: {
    onAddLabelStatus: function () {
      openModalRoute(this, "add_shipping_type");
    },
    onShippingTypeDelete: async function (status) {
      const confirmationResult = await confirmDelete(
        this.$t("shipping_type"),
        status.shipping_type
      );
      if (confirmationResult == "OK") {
        this.$emit("deleted", status.shipping_type_id);
      }
    },
    onShippingTypeClick: function ({ shipping_type_id, shipping_type, service_code }) {
      if (shipping_type_id == "") {
        return;
      }
      openModalRoute(this, "edit_shipping_type", {
        shipping_type_id,
        shipping_type,
        service_code,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-shipping-types {
  .dt-list-item--text:nth-child(1) {
    /* flex: 1.3;
    font-weight: 600;
    cursor: pointer; */
  }
  .dt-list-item--icon:nth-child(3) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .color-picker-value {
    }
  }
}
</style>
